import { Component, Input } from '@angular/core';
import { TextComponentData, TextComponentTypes } from '@finder/features/detail/components/text/text.interface';

@Component({
    selector: 'finder-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss']
})
export class TextComponent {

    @Input() public textData: TextComponentData;
    @Input() public type: TextComponentTypes;
    @Input() public class?: string;

    constructor() { }
}
